/* 🤖 this file was generated by svg-to-ts */
export const matIconStayCurrentPortrait: {
  name: 'stay-current-portrait';
  data: string;
} = {
  name: 'stay-current-portrait',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 1.01 7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/></svg>`
};
